import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setErrorMessage, setSuccessMessage } from "../slices/messageSlice";
import { CreateNewUser } from "../services/UserService";

const CreateUser = () => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    address: "",
    contactPerson: "",
    note: "",
    email: "",
    code: "",
    status: "1",
    type: "",
    typeStatus: "",
    country: "",
    social: "",
    socialValue: "",
    deliveryMethod: "",
    birthDay: "",
    source: "",
    totalSales: "0",
    password: "amac2026",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const trimmedUser = {
        ...user,
        firstName: user.firstName.trim(),
        lastName: user.lastName.trim(),
        phoneNumber: user.phoneNumber.trim(),
        address: user.address.trim(),
        contactPerson: user.contactPerson.trim(),
        note: user.note.trim(),
        email: user.email.trim(),
        code: user.code.trim(),
        status: user.status.trim(),
        type: user.type.trim(),
        typeStatus: user.typeStatus.trim(),
        country: user.country.trim(),
        social: user.social.trim(),
        socialValue: user.socialValue.trim(),
        deliveryMethod: user.deliveryMethod.trim(),
        birthDay: user.birthDay.trim(),
        source: user.source.trim(),
        totalSales: user.totalSales.trim(),
        password: user.password.trim(),
      };
      const response = await CreateNewUser(
        trimmedUser.firstName,
        trimmedUser.lastName,
        trimmedUser.phoneNumber,
        trimmedUser.address,
        trimmedUser.contactPerson,
        trimmedUser.note,
        trimmedUser.email,
        trimmedUser.code,
        trimmedUser.status,
        trimmedUser.type,
        trimmedUser.typeStatus,
        trimmedUser.country,
        trimmedUser.social,
        trimmedUser.socialValue,
        trimmedUser.deliveryMethod,
        trimmedUser.birthDay,
        trimmedUser.source,
        trimmedUser.totalSales,
        trimmedUser.password
      );
      if (response.status_code === 200) {
        dispatch(setSuccessMessage("Tạo người dùng thành công!"));
        navigate("/user-management");
      } else {
        dispatch(setErrorMessage(response.message || "Có lỗi xảy ra"));
      }
    } catch (error) {
      dispatch(setErrorMessage("Có lỗi xảy ra khi tạo người dùng"));
    }
  };

  return (
    <div className="flex justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
      <div className="w-full max-w-5xl">
        <h1 className="text-3xl font-bold text-center text-gray-800 dark:text-white mb-8">
          Tạo Người Dùng Mới
        </h1>

        <form
          onSubmit={handleSubmit}
          className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Thông tin cá nhân */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300 border-b pb-2">
                Thông tin cá nhân
              </h2>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Mã khách hàng
                </label>
                <input
                  type="text"
                  name="code"
                  value={user.code}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Họ
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={user.lastName}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Tên
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={user.firstName}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Ngày sinh
                </label>
                <input
                  type="date"
                  name="birthDay"
                  value={user.birthDay}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
            </div>

            {/* Thông tin liên hệ */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300 border-b pb-2">
                Thông tin liên hệ
              </h2>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Số điện thoại
                </label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={user.phoneNumber}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={user.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Địa chỉ
                </label>
                <input
                  type="text"
                  name="address"
                  value={user.address}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Quốc gia
                </label>
                <input
                  type="text"
                  name="country"
                  value={user.country}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
            </div>

            {/* Thông tin bổ sung */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300 border-b pb-2">
                Thông tin bổ sung
              </h2>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Loại khách hàng
                </label>
                <input
                  type="text"
                  name="type"
                  value={user.type}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Trạng thái
                </label>
                <input
                  type="text"
                  name="status"
                  value={user.status}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Phương thức giao hàng
                </label>
                <input
                  type="text"
                  name="deliveryMethod"
                  value={user.deliveryMethod}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Tổng doanh số
                </label>
                <input
                  type="text"
                  name="totalSales"
                  value={user.totalSales}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Mật khẩu
                </label>
                <input
                  type="text"
                  name="password"
                  value={user.password}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
            </div>

            {/* Thông tin mạng xã hội */}
            <div className="space-y-4 md:col-span-3">
              <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300 border-b pb-2">
                Thông tin mạng xã hội
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Mạng xã hội
                  </label>
                  <input
                    type="text"
                    name="social"
                    value={user.social}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Tài khoản mạng xã hội
                  </label>
                  <input
                    type="text"
                    name="socialValue"
                    value={user.socialValue}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Ghi chú
                </label>
                <textarea
                  name="note"
                  value={user.note}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  rows="3"
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-4 mt-6">
            <button
              type="button"
              onClick={() => navigate("/users")}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
            >
              Hủy
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
            >
              Tạo người dùng
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUser;
